import styled, {createGlobalStyle} from "styled-components";
import {Col, Select, Input} from "antd";

export const PageRoot = styled.div`
    height: calc(100vh - 144px);
    min-height: 500px;
    display: grid;
    grid-template-columns: 60% 1fr;
    grid-template-rows: auto 1fr;
    overflow: hidden;
    padding: 12px;
    box-sizing: border-box;
    gap: 12px;
    background: #f5f6f1;

    @media (max-width: 991px) {
        height: auto;
        min-height: auto;
        overflow: visible;
        grid-template-columns: 1fr;
        grid-template-rows: auto auto auto;
    }
`;

export const FiltersBar = styled.div`
    grid-column: 1 / -1;
    grid-row: 1;
    min-width: 0;

    @media (max-width: 991px) {
        grid-column: 1;
        grid-row: 1;
    }
`;

export const FilterCol = styled(Col)`
    @media (min-width: 992px) {
        flex: ${props => props.$grow || 1} 1 ${props => 200 * (props.$grow || 1)}px;
        max-width: none;
    }
`;

export const FilterItem = styled.div`
    display: flex;
    flex-direction: column;

    .ant-select {
        display: flex;
        margin-bottom: 0;
    }
`;

export const FilterItemLabel = styled.h5`
    margin: 0 0 4px 0;
    font-weight: 500;
    font-size: 13px;
    color: #666;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const TablesColumn = styled.div`
    grid-column: 1;
    grid-row: 2;
    display: flex;
    flex-direction: column;
    min-height: 0;
    min-width: 0;
    overflow: hidden;

    @media (max-width: 991px) {
        grid-column: 1;
        grid-row: 2;
        overflow: visible;
    }
`;

export const TabsBar = styled.div`
    flex: 0 0 auto;
    display: inline-flex;
    gap: 2px;
    width: fit-content;
    background: #ececea;
    border-radius: 10px;
    padding: 2px;
`;

export const TabButton = styled.button`
    border: none;
    background: ${props => (props.$active ? "#fff" : "transparent")};
    color: ${props => (props.$active ? "rgba(0, 0, 0, 0.85)" : "rgba(0, 0, 0, 0.45)")};
    font-weight: ${props => (props.$active ? 600 : 500)};
    box-shadow: ${props => (props.$active ? "0 1px 2px rgba(0, 0, 0, 0.08)" : "none")};
    border-radius: 8px;
    padding: 4px 12px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.15s ease;

    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
        color: rgba(0, 0, 0, 0.85);
    }
`;

export const TabCount = styled.span`
    font-size: 10px;
    color: rgba(0, 0, 0, 0.45);
    margin-left: 4px;
`;

export const TabsRow = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
    padding: 4px;
`;

export const TabFilters = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
`;

export const FilterSelect = styled(Select).attrs({
    dropdownClassName: "live-operation-filter-dropdown"
})`
    width: 208px !important;
    flex-shrink: 0;

    .ant-select-selector {
        background: #ececea !important;
        border: 1px solid #e1e2dc !important;
        border-radius: 10px !important;
        height: 32px !important;
        display: flex !important;
        align-items: center !important;
        padding: 0 11px !important;
    }

    .ant-select-selection-item,
    .ant-select-selection-placeholder {
        font-size: 12px !important;
        line-height: 30px !important;
    }
`;

export const FilterSearchInput = styled(Input)`
    width: 220px !important;
    flex-shrink: 0;
    background: #ececea !important;
    border: 1px solid #e1e2dc !important;
    border-radius: 10px !important;
    height: 32px !important;
    font-size: 12px !important;

    .ant-input {
        background: transparent !important;
        font-size: 12px !important;
    }

    .anticon {
        color: rgba(0, 0, 0, 0.45);
    }

    &:hover,
    &:focus,
    &.ant-input-affix-wrapper-focused {
        background: #ececea !important;
        border-color: #d5d6d0 !important;
    }
`;

export const ActiveTableRow = styled.div`
    flex: 1 1 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    @media (max-width: 991px) {
        flex: none;
        overflow: visible;
    }
`;

export const TableFillArea = styled.div`
    flex: 1 1 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: #fff;
    border: 1px solid #e5e5e0;
    border-radius: 10px;

    /*
     * 991px altında PageRoot "height: auto"ya düşüyor (bkz. yukarıdaki PageRoot), yani artık
     * dağıtılacak sabit bir yükseklik yok. Bu durumda flex:1 + min-height:0 zincirinin en
     * altındaki bu eleman büyüyecek boşluk bulamayıp 0 yüksekliğe çöküyordu (tablo "kayboluyor"
     * gibi görünüyordu) — burada MapColumn'daki gibi sabit bir min-height ile taban veriliyor.
     */
    @media (max-width: 991px) {
        flex: none;
        min-height: 400px;
        overflow: visible;
    }
`;

export const MapColumn = styled.div`
    grid-column: 2;
    grid-row: 2;
    min-height: 260px;
    min-width: 0;

    @media (max-width: 991px) {
        grid-column: 1;
        grid-row: 3;
        height: 400px;
        min-height: 400px;
    }
`;

export const LiveOperationGlobalStyle = createGlobalStyle`
    .live-operation-group-row > td {
        background: #f5f5f5 !important;
        font-weight: 600;
    }

    .live-operation-group-row > td:first-child {
        border-left: 4px solid transparent;
    }

    .live-operation-group-row--queue > td:first-child {
        border-left-color: #faad14;
    }

    .live-operation-group-row--courier > td:first-child {
        border-left-color: #237804;
    }

    .live-operation-group-row--courier > td {
        background: #ecf0ea !important;
    }

    .live-operation-burning-row > td {
        background: #fef9f8 !important;
    }

    .live-operation-fill-table {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .live-operation-fill-table .ant-spin-nested-loading,
    .live-operation-fill-table .ant-spin-container,
    .live-operation-fill-table .ant-table {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
    }

    .live-operation-fill-table .ant-table-container {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
    }

    .live-operation-fill-table .ant-table-content {
        flex: 1;
        min-height: 0;
        overflow-y: auto !important;
    }

    .live-operation-fill-table .ant-table-measure-row {
        display: none !important;
    }

    .live-operation-fill-table .ant-table-thead > tr > th {
        position: sticky;
        top: 0;
        z-index: 2;
        background: #fff !important;
    }

    .live-operation-fill-table .ant-table-thead > tr > th,
    .live-operation-fill-table .ant-table-tbody > tr > td {
        font-size: 12px !important;
        line-height: 1.4 !important;
        padding: 6px 12px !important;
    }

    .live-operation-fill-table .ant-table-tbody > tr > td,
    .live-operation-fill-table .ant-table-thead > tr > th {
        border-bottom: 1px solid #dbe0d9 !important;
    }

    .live-operation-filter-dropdown .ant-select-item {
        font-size: 12px;
        min-height: 28px;
        padding: 4px 12px;
    }

    @media screen and (max-width: 991px) {
        .live-operation-fill-table,
        .live-operation-fill-table .ant-spin-nested-loading,
        .live-operation-fill-table .ant-spin-container,
        .live-operation-fill-table .ant-table,
        .live-operation-fill-table .ant-table-container {
            height: auto;
            overflow: visible;
            display: block;
        }

        .live-operation-fill-table .ant-table-thead > tr > th {
            position: static;
        }
    }
`;
